export interface selectedOptionsType {
  value: string;
  label: string;
}

export interface LogOption {
  env: string;
  label: string;
  value: string;
}
export interface LogsGroupOptions {
  label: string;
  value: string;
  options: LogOption[];
}

export const ES_LOGS = {
  label: 'Elasticsearch',
  value: 'Elasticsearch',
  options: [
    {
      label: 'elasticsearch.log',
      value: 'elasticsearch.log',
      env: 'ES',
    },
    {
      label: 'supervisord.log',
      value: 'supervisord.log',
      env: 'ES',
    },
    {
      label: 'supervisord.es.log',
      value: 'supervisord.es.log',
      env: 'ES',
    },
    {
      label: 'supervisord.pa.log',
      value: 'supervisord.pa.log',
      env: 'ES',
    },
    {
      label: 'elasticsearch_index_search_slowlog.log',
      value: 'elasticsearch_index_search_slowlog.log',
      env: 'ES',
    },
    {
      label: 'elasticsearch_index_indexing_slowlog.log',
      value: 'elasticsearch_index_indexing_slowlog.log',
      env: 'ES',
    },
    {
      label: 'read-node-discovery-file.general.log.*',
      value: 'read-node-discovery-file.general.log.*',
      env: 'ES',
    },
    {
      label: 'write-node-discovery-file.general.log.*',
      value: 'write-node-discovery-file.general.log.*',
      env: 'ES',
    },
  ],
};

export const SERVICE_PROXY_LOGS = {
  label: 'ServiceProxy',
  value: 'ServiceProxy',
  options: [
    {
      label: 'haproxy.log',
      value: 'haproxy.log',
      env: 'ServiceProxy',
      logPath: '/sdpds/components/serviceproxy/var/output/logs/haproxy.log'
    },
    {
      label: 'supervisord.log',
      value: 'supervisord.log',
      env: 'ServiceProxy',
    },
  ],
};

export const SDPD_AGENT_LOGS = {
  label: 'SDPDAgent',
  value: 'SDPDAgent',
  options: [
    {
      label: 'sdpd_agent.log.*',
      value: 'sdpd_agent.log.*',
      env: 'SDPDAgent',
    },
    {
      label: 'supervisord.log',
      value: 'supervisord.log',
      env: 'SDPDAgent',
    },
    {
      label: 'supervisord.sdpd.log',
      value: 'supervisord.sdpd.log',
      env: 'SDPDAgent',
    },
    {
      value: 'sdpd_metrics.log.*',
      label: 'sdpd_metrics.log.*',
      env: 'SDPDAgent',
    },
    {
      label: 'service_log.*',
      value: 'service_log.*',
      env: 'SDPDAgent',
    },
  ],
};

export const LOG_PUSHER_LOGS = {
  value: 'LogPusher',
  label: 'LogPusher',
  options: [
    {
      label: 'cw.agent.log.*',
      value: 'cw.agent.log.*',
      env: 'LogPusher',
    },
    {
      label: 'cwagent.metrics.log.*',
      value: 'cwagent.metrics.log.*',
      env: 'LogPusher',
    },
    {
      label: 'supervisord.log',
      value: 'supervisord.log',
      env: 'LogPusher',
    },
  ],
};

export const INSTANCE_CONTROLLER_LOGS = {
  value: 'InstanceController',
  label: 'InstanceController',
  options: [
    {
      label: 'PMAdmin.log',
      value: 'PMAdmin.log',
      env: 'InstanceController',
    },
  ],
};

export const BOOT_LOGS = {
  value: 'BootLogs',
  label: 'BootLogs',
  options: [
    {
      label: 'a9-ec2-boot-start.log',
      value: 'a9-ec2-boot-start.log',
      env: 'Boot',
      logPath: '/apollo/var/logs/a9-ec2-boot-start.log'
    },
  ],
};

export const CONTAINER_LOGS = {
  value: 'Container',
  label: 'Container',
  options: [
    {
      label: 'opensearch-container-wrapper.log',
      value: 'opensearch-container-wrapper.log',
      env: 'Container',
    },
    {
      label: 'opensearch-container-process-manager.log',
      value: 'opensearch-container-process-manager.log',
      env: 'Container',
    },
  ],
};

export const EC2_PREPARE_LOGS = {
  value: 'OpenSearchEC2Prepare',
  label: 'OpenSearchEC2Prepare',
  options: [
    {
      label: 'opensearch-ec2-prepare.log',
      value: 'opensearch-ec2-prepare.log',
      env: 'OpenSearchEC2Prepare',
    },
  ],
};

export const KBN_LOGS = {
  value: 'Kibana',
  label: 'Kibana',
  options: [
    {
      label: 'kibana.log',
      value: 'kibana.log',
      env: 'Kibana',
    },
    {
      value: 'supervisord.log',
      label: 'supervisord.log',
      env: 'Kibana',
    },
    {
      label: 'supervisord.kibana.log',
      value: 'supervisord.kibana.log',
      env: 'Kibana',
    },
  ],
};

export const tableSearchParameters: selectedOptionsType[] = [
  {
    value: 'all',
    label: 'All nodes',
  },
  {
    value: 'data',
    label: 'Data nodes',
  },
  {
    value: 'master',
    label: 'Master nodes',
  },
  {
    value: 'warm',
    label: 'Warm nodes',
  },
];

export interface NodeCommandInput {
  /** Label shown above the input field. */
  label: string;
  /** Placeholder text for the input field. */
  placeholder?: string;
  /** Value prefilled in the input when the command is selected. */
  defaultValue?: string;
  /** When true, the command cannot be run until the input is non-empty. */
  required?: boolean;
  /**
   * Preset values offered as autosuggestions. The field still accepts free
   * text, so these are convenience shortcuts, not an allowlist.
   */
  suggestions?: string[];
  /**
   * For dedicated-tool commands (toolPath set), the request-argument name the
   * entered value is sent as (e.g. dmesg's `options`). Shell commands ignore
   * this -- their input is appended to `args` instead.
   */
  argName?: string;
}

export interface NodeCommand {
  /** Stable id used for the dropdown item and lookup. */
  id: string;
  /** Label shown in the Commands dropdown. */
  label: string;
  /**
   * Mechanic tool path to invoke. Shell commands (baseCmd/args) use the default
   * aes/domain/dp/node/shell; a command may override this to call a dedicated
   * tool that takes only domain_identifier + instance_id.
   */
  toolPath?: string;
  /** base_cmd passed to aes/domain/dp/node/shell. Omit for dedicated-tool commands. */
  baseCmd?: string;
  /** args string passed to aes/domain/dp/node/shell. Omit for dedicated-tool commands. */
  args?: string;
  /** Short help shown as the dropdown item description. */
  description?: string;
  /**
   * Optional free-text argument taken from the user (e.g. a directory to list).
   * When present, the entered value is appended to `args` at run time.
   */
  input?: NodeCommandInput;
  /**
   * How the command result should be rendered:
   *  - 'shell'    : plain text output in a code viewer (default).
   *  - 'keyValue' : structured record rendered as key/value pairs, with a
   *                 raw-JSON toggle. Use for dedicated tools returning objects.
   */
  resultType?: 'shell' | 'keyValue';
}

/** Mechanic tool path used for plain shell commands. */
export const NODE_SHELL_TOOL_PATH = 'aes/domain/dp/node/shell';

/**
 * Predefined read-only shell commands runnable against a selected node via the
 * Commands dropdown. Keep these non-destructive -- they execute on data plane
 * hosts through aes/domain/dp/node/shell. Add new entries here as needed.
 */
export const NODE_COMMANDS: NodeCommand[] = [
  {
    id: 'dockerPsAll',
    label: 'docker ps -a',
    baseCmd: 'docker',
    args: 'ps -a',
    description: 'List all containers (running and stopped)',
  },
  {
    id: 'dockerImages',
    label: 'docker images',
    baseCmd: 'docker',
    args: 'images --no-trunc',
    description: 'List container images on the node',
  },
  {
    id: 'lsPath',
    label: 'ls -la <path>',
    baseCmd: 'ls',
    args: '-la',
    description: 'List directory contents for the provided path',
    input: {
      label: 'Path to list',
      placeholder: '/var/opt/opensearch/var/logs',
      defaultValue: '/var/opt/opensearch/var/logs',
      required: true,
      suggestions: [
        '/sdpds/components/',
        '/var/opt/opensearch/',
        '/apollo/env/',
        '/apollo/var/logs',
      ],
    },
  },
  {
    id: 'dfHuman',
    label: 'df -h',
    baseCmd: 'df',
    args: '-h',
    description: 'Show disk space usage per filesystem',
  },
  {
    id: 'freeMem',
    label: 'free -m',
    baseCmd: 'free',
    args: '-m',
    description: 'Show memory usage in MB',
  },
  {
    id: 'diskLayout',
    label: 'disk layout',
    baseCmd: 'cat',
    args: '/sdpds/components/OpenSearchEC2Prepare/var/config/disk_state.json',
    description: 'Show disk-state layout recorded by OpenSearchEC2Prepare',
  },
  {
    id: 'isOsContainerized',
    label: 'is OS containerized',
    toolPath: 'aes/domain/dp/node/is-os-containerized',
    description: 'Check whether OpenSearch runs as a container on this node',
    resultType: 'keyValue',
  },
];

export interface LogAction {
  id: string;
  displayName: string;
  paths: {
    [key: string]: string;
  };
}

export const LOG_ACTIONS: LogAction[] = [
  {
    id: 'downloadLog',
    displayName: 'Download',
    paths: {
      apolloLog: 'apollo/env/download-log',
      fileLog: 'file/download',
    },
  },
  {
    id: 'liveLog',
    displayName: 'View Live',
    paths: {
      apolloLog: 'apollo/env/follow-log',
      fileLog: 'file/follow',
    },
  }
];

